import {
  PluginTypes,
  currentPluginState,
  initPluginConfig,
  updatePluginOnProductSelection,
  hidePluginIconsOnModelSelections,
  hideOnboardingBackgroundImage,
} from './flormar.config';
import {
  setFlormarAgreementCookie,
  openFlormarKvkkModal,
  closeFlormarKvkkModal,
  setActionButtonsClasses,
} from './flormar.helper';

/**
 * Trigger take a photo input, it is used to take a photo from mobile devices.
 */
export const openPluginDeviceCamera = () => {
  document
    .getElementById('makeupView')
    .contentWindow.window.postMessage(JSON.stringify({ openLiveCamera: '' }), '*');
};

/**
 * Apply selected model to the plugin and switch to makeup step.
 * @param {number} selectedModelIndex - Model index to send into the plugin.
 */
export const applyToMobileModel = (selectedModelIndex) => {
  $('.plugin-wrapper').removeClass('hidden');
  document.getElementById('makeupView').contentWindow.window.postMessage(
    JSON.stringify({
      applyToSelectedModel: selectedModelIndex,
    }),
    '*',
  );
};

// Set selected product names to prevent multiple selection on the same category.
let SelectedProductNames = {
  activeCategory: null,
  activeProduct: null,
};
let activeColorID;
let isPluginLoaded = false;
let liveCameraClicked = false;

// Represents used carousels as enum instead of magic strings.
const Carousels = {
  CATEGORIES: '.categories-wrapper',
  PRODUCTS: '.products-wrapper',
  COLORS: '.colors-wrapper',
  ACTIVE_PRODUCT: '.active-product-wrapper',
};

const MobileSteps = {
  FIRST_STEP: 'category-step',
  SECOND_STEP: 'model-step',
  THIRD_STEP: 'makeup-step',
};

// jQuery fast -> 200, slow -> 600.
const IMAGE_ANIMATION_SPEED = 200;

/**
 * If .owl-stage has the same width with .owl-stage-outer, no need to slide.
 * Hides navigation icons in Owl carousel.
 * @param {string} owlSelector - jQuery selector of carousel element.
 */
const hideNavigationOnShortCarousel = (owlSelector) => {
  if (
    $(owlSelector).find('.owl-stage').width() <= $(owlSelector).find('.owl-stage-outer').width()
  ) {
    $(owlSelector).find('.owl-nav').addClass('passive');
  }
};

/**
 * Flormar template use the same carousel type all the time.
 * Just make the margin optional so that it can be customized.
 * @param {string} owlSelector - jQuery selector of carousel element.
 * @param {number} [marginValue=20] - Default margin between carousel items.
 */
const makeFlormarCarousel = ({ owlSelector, marginValue = 20 }) => {
  $(owlSelector).owlCarousel({
    onInitialized: () => hideNavigationOnShortCarousel(owlSelector),
    dots: false,
    nav: true,
    navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>'],
    items: 1,
    autoWidth: true,
    margin: marginValue,
    responsive: {
      0: {
        margin: marginValue * 0.6,
      },
      999: {
        margin: marginValue * 0.7,
      },
    },
  });
};

/**
 * Read and post the image that user has taken to upload on mobile.
 */
const readFile = () => {
  const takePhotoImage = document.querySelector('#photoMakeupInput');
  if (!takePhotoImage.files || takePhotoImage.files[0].length == 0) return;
  const FR = new FileReader();

  FR.addEventListener('load', function (e) {
    const imgBase64 = e.target.result.split(',')[1];
    document
      .getElementById('makeupView')
      .contentWindow.window.postMessage(
        JSON.stringify({ loadimgBase64: 'data:image/png;base64,' + imgBase64 }),
        '*',
      );
    document
      .getElementById('makeupView')
      .contentWindow.window.postMessage(JSON.stringify({ hideTryLabel: '' }), '*');
    document
      .getElementById('makeupView')
      .contentWindow.window.postMessage(JSON.stringify({ hideChooseModelButton: '' }), '*');
    document
      .getElementById('makeupView')
      .contentWindow.window.postMessage(JSON.stringify({ hideTakePhotoWithAppButton: '' }), '*');
  });
  FR.readAsDataURL(takePhotoImage.files[0]);
  takePhotoImage.value = null;
};

/**
 * There is another page in mobile, that is why
 * we set another function to create carousels exclusive for mobile.
 */
const setCarouselsForMobile = () => {
  // Destroy exising carousels if there is any.
  helpers.destroyExistingOwl(Carousels.PRODUCTS);
  helpers.destroyExistingOwl(Carousels.COLORS);
  // Hide previous colors and active product containers on new category selection.
  $(Carousels.COLORS).addClass('passive');
  $(Carousels.ACTIVE_PRODUCT).addClass('unvisible');

  // Hide product and cart buttons.
  $('.plugin-buttons button, .action-buttons button').removeClass('active');
  const categoryProducts = pulpo.products.filter((product) =>
    product.categ_id[1].includes(SelectedProductNames.activeCategory),
  );
  helpers.assignCategoryProducts({
    container: Carousels.PRODUCTS,
    categoryProducts,
  });
  // Animate images on load.
  $('.product-image').css('opacity', '0');
  $('.product-image').bind('load', function () {
    $(this).animate({ opacity: 1 }, IMAGE_ANIMATION_SPEED);
  });
  makeFlormarCarousel({ owlSelector: Carousels.PRODUCTS, marginValue: 18 });
};

/**
 * Change the interface to move on the last page, the makeup with plugin.
 */
const switchToMobileMakeupStep = () => {
  // It takes time for plugin to load on mobile, wait for it being loaded.
  if (!currentPluginState.isPluginAvailable && currentPluginState.isInitialLoad) {
    setTimeout(() => switchToMobileMakeupStep(), 200);
    return;
  }
  $('#container').removeClass().addClass(MobileSteps.THIRD_STEP);
  $(Carousels.PRODUCTS).removeClass('passive');
  $('.toggle-icon, .expand-icon').removeClass('passive');
  $('.plugin-icon.close-icon').addClass('passive');
  setCarouselsForMobile();
  hidePluginIconsOnModelSelections();
};

const hideFlormarActiveProduct = () => {
  $('.go-product-btn, .add-cart-btn').removeClass('active');
  $(Carousels.ACTIVE_PRODUCT).addClass('unvisible');
};

$(() => {
  openFlormarKvkkModal();
  if ($(window).width() > helpers.Breakpoints.WIDE_TABLET) {
    helpers.setPluginAspectRatio({ bufferWidth: 50, shouldAddTopMargin: true });
    $(window).resize(() =>
      helpers.setPluginAspectRatio({ bufferWidth: 50, shouldAddTopMargin: true }),
    );
    $('.categories-wrapper.web').removeClass('passive');
    makeFlormarCarousel({ owlSelector: Carousels.CATEGORIES });

    // Category item listener only for web.
    $('.category-item').click(function () {
      // Do not trigger if the same category is getting clicked.
      // Owl adds the active class quickly, that's why we check the texts.
      if ($(this).data('name').trim() == SelectedProductNames.activeCategory) {
        return;
      }
      if (pulpo.null_product_active) {
        helpers.removeMakeup(SelectedProductNames.activeCategory);
        helpers.removeProduct();
      }
      $('.category-item').removeClass('active');
      $(this).addClass('active');
      // Destroy exising carousels if there is any.
      helpers.destroyExistingOwl(Carousels.PRODUCTS);
      helpers.destroyExistingOwl(Carousels.COLORS);
      // Hide previous colors and active product containers on new category selection.
      $(Carousels.COLORS).addClass('passive');
      $(Carousels.ACTIVE_PRODUCT).addClass('unvisible');

      // Hide product and cart buttons.
      $('.plugin-buttons button, .action-buttons button').removeClass('active');
      const categoryName = $(this).data('name').trim();
      changeFlormarPluginOnNailCategory(categoryName);
      const categoryProducts = pulpo.products.filter((product) =>
        product.categ_id[1].includes(categoryName),
      );
      helpers.assignCategoryProducts({
        container: Carousels.PRODUCTS,
        categoryProducts,
      });
      // Animate images on load.
      $('.product-image').css('opacity', '0');
      $('.product-image').bind('load', function () {
        $(this).animate({ opacity: 1 }, IMAGE_ANIMATION_SPEED);
      });
      makeFlormarCarousel({ owlSelector: Carousels.PRODUCTS, marginValue: 18 });
      SelectedProductNames = { activeCategory: categoryName, activeProduct: null };
    });
  } else {
    $('#container').addClass(MobileSteps.FIRST_STEP);
    $(Carousels.CATEGORIES).removeClass('owl-carousel');
    $('.categories-wrapper.mobile, .mobile-top-navigation').removeClass('passive');
    $('.selections-wrapper').addClass('scroll-preventive');

    // If there is more than 4 category, it means there will be more than two(default) rows.
    if ($('.category-item').length > 4) {
      $(Carousels.CATEGORIES).removeClass('double-row');
    }
    $('.plugin-wrapper').addClass('hidden');
    $('.plugin-buttons').addClass('passive');

    const MOBILE_BACK_ICON = '.mobile-top-navigation .back-icon';
    // Category item listener only for mobile.
    $('.category-item').click(function () {
      $(MOBILE_BACK_ICON).removeClass('passive');
      if (pulpo.null_product_active) {
        helpers.removeMakeup(SelectedProductNames.activeCategory);
        helpers.removeProduct();
      }
      $('#container').removeClass().addClass(MobileSteps.SECOND_STEP);
      $('.models-wrapper').removeClass('passive');
      hidePluginIconsOnModelSelections();
      const categoryName = $(this).data('name').trim();
      changeFlormarPluginOnNailCategory(categoryName);
      SelectedProductNames.activeCategory = categoryName;
    });

    // Product listener only for mobile.
    $(Carousels.PRODUCTS).on('click', '.product', function () {
      if ($('.colors-and-product-wrapper').length == 0) {
        $(`${Carousels.COLORS}, ${Carousels.ACTIVE_PRODUCT}`).wrapAll(
          '<div class="colors-and-product-wrapper"></div>',
        );
      }
    });

    $(MOBILE_BACK_ICON).click(() => {
      $('.plugin-wrapper').addClass('hidden');
      $('.action-buttons button').removeClass('active');
      $('.toggle-icon, .expand-icon').addClass('passive');
      helpers.removeProduct();
      if ($('#container').hasClass(MobileSteps.SECOND_STEP)) {
        $('#container').removeClass().addClass(MobileSteps.FIRST_STEP);
        $(MOBILE_BACK_ICON).addClass('passive');
      } else if ($('#container').hasClass(MobileSteps.THIRD_STEP)) {
        $('#container').removeClass().addClass(MobileSteps.SECOND_STEP);
        $('.selections-wrapper').removeClass('passive');
        if (liveCameraClicked) {
          document
            .getElementById('makeupView')
            .contentWindow.window.postMessage(JSON.stringify({ closeLiveCamera: '' }), '*');
        }
        helpers.destroyExistingOwl(Carousels.COLORS);
        helpers.destroyExistingOwl(Carousels.PRODUCTS);
        // If colors and active product wrapper is contained in single div, unwrap them.
        if ($('.colors-and-product-wrapper').length > 0) {
          $(Carousels.COLORS).unwrap();
        }
        SelectedProductNames.activeProduct = null;
      }
    });
  }

  makeupView.addEventListener('load', () => initPluginConfig());

  $('#flormar-checkbox').change((e) => {
    const isChecked = $(e.currentTarget).is(':checked');
    if (isChecked) {
      $('.flormar-modal-button').attr('disabled', false);
      return;
    }
    $('.flormar-modal-button').attr('disabled', true);
  });

  $('.flormar-modal-button').click(() => {
    helpers.saveLogAgreement();
    setFlormarAgreementCookie();
    closeFlormarKvkkModal();
  });

  $(Carousels.PRODUCTS).on('click', '.product', function () {
    if ($(this).text() == SelectedProductNames.activeProduct) {
      return;
    }
    $('.product').removeClass('active');
    $(this).addClass('active');
    activeColorID = $(this).data('id');
    const productName = $(this).find('.product-name').text().trim(),
      productCode = $(this).data('code'),
      productImage = $(this).find('.product-image').attr('src'),
      productColor = $(this).data('color-name'),
      productCategory = $(this).data('category');

    $('.active-product-image').attr('src', productImage);
    $('.active-product-name').html(productColor);
    if (!pulpo.null_product_active) {
      helpers.applySelectedProduct({
        productCategory,
        productCode,
        productColor,
        productName,
        pluginSelector: 'makeupView',
      });
      helpers.toggleProductButtons({
        activeColorID,
        goProductSelector: '.go-to-product-btn',
        addCartSelector: '.add-to-cart-btn',
      });
      $(Carousels.ACTIVE_PRODUCT).removeClass('unvisible');
    } else {
      hideFlormarActiveProduct();
      helpers.removeMakeup(SelectedProductNames.activeCategory);
      helpers.removeProduct();
    }
    helpers.destroyExistingOwl(Carousels.COLORS);

    const filteredProductsByName = pulpo.products
      .filter((product) => product.name == productName)
      .sort((a, b) => a.color_code - b.color_code);
    helpers.assignProductColors({
      productList: filteredProductsByName,
      productName,
      productCategory,
      colorsContainer: Carousels.COLORS,
    });
    $(Carousels.COLORS).removeClass('passive');
    makeFlormarCarousel({ owlSelector: Carousels.COLORS, marginValue: 10 });
    updatePluginOnProductSelection();
    $('.color').first().addClass('active');
    SelectedProductNames.activeProduct = $(this).text();
  });

  $(Carousels.COLORS).on('click', '.color', function () {
    $('.color').removeClass('active');
    $(this).addClass('active');

    const selectedArColor = $('.color.active .ar-color');
    $('.color .ar-color').css('box-shadow', 'none');
    selectedArColor.css('box-shadow', `${selectedArColor.css('background-color')} 0px 0px 0px 2px`);
    if ($(this).hasClass('null-product')) {
      selectedArColor.css('box-shadow', '#E5E5E5 0px 0px 0px 2px');
      hideFlormarActiveProduct();
      helpers.removeMakeup(SelectedProductNames.activeCategory);
      helpers.removeProduct();
      $('.action-buttons button').removeClass('active');
      return;
    }
    activeColorID = $(this).data('id');
    const productName = $(this).data('product-name'),
      productCategory = $(this).data('category'),
      productColor = $(this).data('color-name'),
      productCode = $(this).data('product-code'),
      productImage = $(this).data('product-image');

    $('.active-product-image').attr('src', productImage);
    $('.active-product-name').html(productColor);
    $(Carousels.ACTIVE_PRODUCT).removeClass('unvisible');
    helpers.applySelectedProduct({
      productCategory,
      productCode,
      productColor,
      productName,
      pluginSelector: 'makeupView',
    });
    helpers.toggleProductButtons({
      activeColorID,
      goProductSelector: '.go-to-product-btn',
      addCartSelector: '.add-to-cart-btn',
    });
    setActionButtonsClasses();
  });

  $('.go-to-product-btn').on('click', function () {
    if (helpers.isFlormarMobileApp()) {
      helpers.flormarAppGoToProduct({ activeColorID, products: pulpo.products });
      return;
    }

    helpers.goProductAction({ activeColorID, products: pulpo.products });
  });

  $('.add-to-cart-btn').click(function () {
    if (helpers.isFlormarMobileApp()) {
      helpers.flormarAppAddToCart({ activeColorID, products: pulpo.products });
      return;
    }
    helpers.addCartAction({ activeColorID, products: pulpo.products });
  });

  $('.plugin-wrapper .toggle-icon').click(() => {
    if (liveCameraClicked) {
      document
        .getElementById('makeupView')
        .contentWindow.window.postMessage(JSON.stringify({ liveMakeupSliderToggler: '' }), '*');
      return;
    }
  });

  $('.plugin-wrapper .close-icon').click(() => {
    liveCameraClicked = false;
    document
      .getElementById('makeupView')
      .contentWindow.window.postMessage(JSON.stringify({ clickBackButton: '' }), '*');
    document
      .getElementById('makeupView')
      .contentWindow.window.postMessage(JSON.stringify({ removeProduct: '' }), '*');
    $('.toggle-icon, .close-icon').addClass('passive');
  });

  $('.plugin-wrapper .expand-icon').click(function () {
    $(this).toggleClass('active');
    $('#container').toggleClass('full-screen white-background');
  });

  window.addEventListener('message', function (event) {
    currentPluginState.pluginStep = event.data.data && event.data.data.v1;
    const PluginEvents = helpers.PluginEvents;
    const LegacyPluginEvents = helpers.LegacyPluginEvents;
    const eventId = event.data.event_id;

    if (eventId == 'isDictLoaded') {
      isPluginLoaded = event.data.data;
    }

    if (eventId == 'isChangedCameraOutput') {
      hideOnboardingBackgroundImage();
      switchToMobileMakeupStep();
    }

    // Plugin is at the first step, showing "Choose a model" or "Take a photo" buttons.
    if (currentPluginState.pluginStep == 'init') {
      $('.plugin-wrapper .close-icon, .plugin-wrapper .toggle-icon').addClass('passive');
    }

    // Plugin is at the second step, the user clicked "Choose a model" to select model.
    if ([PluginEvents.CHOOSE_MODEL, LegacyPluginEvents.CHOOSE_MODEL].includes(eventId)) {
      $('.plugin-wrapper .close-icon').removeClass('passive');
      $('.plugin-wrapper .toggle-icon').addClass('passive');
      currentPluginState.hasFaceRecognitionError = false;
      liveCameraClicked = false;
    }

    // Plugin is at the third and last step, the product is applied to the plugin.
    if (eventId == PluginEvents.MAKEUP_APPLIED || eventId == PluginEvents.NAIL_APPLIED) {
      if (!currentPluginState.hasFaceRecognitionError) {
        $('.plugin-wrapper .toggle-icon').removeClass('passive');
        $(currentPluginState.pluginSelector).removeClass('hidden');
        currentPluginState.isPluginAvailable = true;
        currentPluginState.isInitialLoad = false;
      }
    }

    // If the user face is not recognised, hide icons and labels.
    // Plugin will re-loaded right afterwards.
    if ([PluginEvents.FACE_NOT_FOUND, LegacyPluginEvents.FACE_NOT_FOUND].includes(eventId)) {
      currentPluginState.hasFaceRecognitionError = true;
      $('.plugin-wrapper .close-icon, .plugin-wrapper .toggle-icon').addClass('passive');
      document
        .getElementById('makeupView')
        .contentWindow.window.postMessage(JSON.stringify({ hideBeforeAfterLabels: '' }), '*');
    }

    // User calls isReloadedDueToFallback function on falback page.
    if (currentPluginState.pluginStep == 'isReloadedDueToFallback') {
      $('.mobile-top-navigation .back-icon').click();
    }

    // The user is in the take a photo step, and they taken their photos.
    if ([PluginEvents.TAKE_PHOTO, LegacyPluginEvents.TAKE_PHOTO].includes(eventId)) {
      $('.plugin-wrapper .close-icon').removeClass('passive');
      $('.plugin-wrapper .toggle-icon').addClass('passive');
    }

    // The user confirmed and applied the photo they taken.
    if (currentPluginState.pluginStep == 'clickedApplyButton') {
      $('.plugin-wrapper .toggle-icon').removeClass('passive');
    }

    if (event.data.data && event.data.data.v2 == 'camera_open') {
      document
        .getElementById('makeupView')
        .contentWindow.window.postMessage(JSON.stringify({ hideBeforeAfterLabels: '' }), '*');
    }

    // Plugin is in the live camera step, the user clicked "Live Camera" button.
    if ([PluginEvents.LIVE_CAMERA].includes(eventId)) {
      $('.plugin-wrapper .close-icon').removeClass('passive');
      $('.plugin-wrapper .toggle-icon').addClass('passive');
      currentPluginState.hasFaceRecognitionError = false;
      liveCameraClicked = true;
      if ($(window).width() < helpers.Breakpoints.WIDE_TABLET) {
        switchToMobileMakeupStep();
        $('.plugin-wrapper').removeClass('hidden');
      }
    }

    if ([PluginEvents.LIVE_CAMERA_READY].includes(eventId)) {
      if ($(window).width() < helpers.Breakpoints.WIDE_TABLET) {
        $('.toggle-icon, .expand-icon').removeClass('passive');
      }
    }

    if ([PluginEvents.SELECT_SPECIFIC_MODEL].includes(eventId)) {
      if ($(window).width() < helpers.Breakpoints.WIDE_TABLET) {
        $('.toggle-icon, .expand-icon').removeClass('passive');
      }
    }
  });

  /**
   * Change the visible plugin on Template depending on the selected category.
   * Set loader time with buffer in mobile since it takes time to load two plugin.
   * @param {string} categoryName - Selected category name.
   */
  const changeFlormarPluginOnNailCategory = (categoryName) => {
    // We control the plugin type when switching between categories.
    if (categoryName == 'Nailpolish' && currentPluginState.pluginType === PluginTypes.MAKEUP) {
      currentPluginState.pluginType = PluginTypes.NAIL;
      $('.model-selection-wrapper, .toggle-icon, .close-icon, .take-photo-wrapper').addClass(
        'passive',
      );
      $('.nail-selection-wrapper').removeClass('passive');
      helpers.swichPluginTypes(true);
      if (liveCameraClicked) {
        document
          .getElementById('makeupView')
          .contentWindow.window.postMessage(JSON.stringify({ openNailChooseModelPage: '' }), '*');
        liveCameraClicked = false;
      } else {
        document
          .getElementById('makeupView')
          .contentWindow.window.postMessage(JSON.stringify({ removeNailCameraButton: '' }), '*');
      }
    } else if (categoryName != 'Nailpolish' && currentPluginState.pluginType === PluginTypes.NAIL) {
      currentPluginState.pluginType = PluginTypes.MAKEUP;
      $('.nail-selection-wrapper, .toggle-icon, .close-icon').addClass('passive');
      $('.model-selection-wrapper, .take-photo-wrapper').removeClass('passive');
      helpers.swichPluginTypes(false);
    }
  };
});
